import styled from '@app/styled';
import { color } from '@app/theme';

export const Container = styled.div`
    color: ${color('text.light.default')};
    font-size: 14px;
    line-height: 1.6;
`;
